import { useMemo } from 'react';

import { localStorageManager } from '../../utils/local-storage-manager';

export const usePersistedGridState = (
  storageKey: string,
  storageManager = localStorageManager,
  storageOptions: any = window,
) => {
  const storage = useMemo(
    () => storageManager?.(storageKey, storageOptions),
    [storageKey, storageOptions, storageManager],
  );

  return storage;
};
